import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么千万用户选择97影院在线观看
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-lg p-6 text-center group cursor-pointer hover:bg-background-200 transition-colors">
              <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                <i className={`${item.icon} text-2xl text-accent-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}